import { motion } from "framer-motion";
import { Logo } from "@/components/Logo";
import { LanguageSwitcher } from "@/i18n";

export function QuizProgress({ step, total, progress }) {
  return (
    <>
      <header className="max-w-3xl w-full mx-auto px-6 py-6 flex items-center justify-between gap-3">
        <Logo imgClassName="h-11" />
        <div className="flex items-center gap-3">
          <LanguageSwitcher variant="light" />
          <span className="text-sm font-semibold text-[#4b5b7c]" data-testid="quiz-step-indicator">
            {step + 1} / {total}
          </span>
        </div>
      </header>

      <div className="max-w-3xl w-full mx-auto px-6">
        <div className="h-2.5 w-full bg-[#eef1f6] rounded-full overflow-hidden">
          <motion.div
            className="h-full bg-[#d7de3b] rounded-full"
            animate={{ width: `${progress}%` }}
            transition={{ duration: 0.4 }}
            data-testid="quiz-progress-bar"
          />
        </div>
      </div>
    </>
  );
}
